module.exports = __webpack_public_path__ + "img/icono-foto.b298186b.png";